import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { createBoqApi } from "../../services/api/boq/boqService";
import toast from "react-hot-toast";

export default function CreateBoq() {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    boq_name: "",
    discipline: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await createBoqApi({
        project_id: projectId,
        boq_name: form.boq_name,
        discipline: form.discipline,
      });

      toast.success("BOQ created successfully");
      navigate(`/projects/view/${projectId}`);
    } catch (err) {
      toast.error("Failed to create BOQ");
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-xl shadow p-6 max-w-xl">
        <h2 className="text-xl font-bold mb-4">Create BOQ</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium">BOQ Name</label>
            <input
              type="text"
              name="boq_name"
              required
              value={form.boq_name}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Discipline</label>
            <select
              name="discipline"
              required
              value={form.discipline}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
            >
              <option value="">Select</option>
              <option value="HVAC">HVAC</option>
              <option value="Electrical">Electrical</option>
              <option value="Civil">Civil</option>
              <option value="Plumbing">Plumbing</option>
            </select>
          </div>

          <div className="flex gap-2">
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 text-white rounded"
            >
              Save
            </button>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-300 rounded"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}